import React from 'react';

const ArrowLeftIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="6px" height="13px" viewBox="0 0 6 12" version="1.1">
      <g id="surface1">
        <path stroke={'none'} fillRule={'nonzero'} fill={'currentColor'} d="M 5.324219 11.816406 C 5.53125 11.816406 5.71875 11.695312 5.796875 11.511719 C 5.878906 11.328125 5.832031 11.117188 5.6875 10.976562 L 1.480469 6.953125 C 0.878906 6.375 0.878906 5.441406 1.480469 4.867188 L 5.6875 0.84375 C 5.886719 0.648438 5.886719 0.335938 5.6875 0.144531 C 5.484375 -0.046875 5.160156 -0.046875 4.957031 0.144531 L 0.753906 4.167969 C -0.25 5.128906 -0.25 6.6875 0.753906 7.648438 L 4.957031 11.671875 C 5.054688 11.765625 5.1875 11.816406 5.324219 11.816406 Z M 5.324219 11.816406 "/>
      </g>
    </svg>
  );
};

export default ArrowLeftIcon;
